import MilwaukeePackoutBuilderApp from './MilwaukeePackoutBuilderApp.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const el = document.getElementById("packout-builder-app");
const wallPlateAvailable = el.getAttribute('wall-plate-available');

if (el) {
	new Vue({
		el,
		render: h => h(MilwaukeePackoutBuilderApp, {
			props: {
				wallPlateAvailable,
			}
		})
	});
}